import { render, staticRenderFns } from "./WidgetEdit.vue?vue&type=template&id=9a0d00e2&"
import script from "./WidgetEdit.vue?vue&type=script&lang=js&"
export * from "./WidgetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports